import styled from "styled-components";
import { Row, Col } from "antd";
import { useEffect, useRef } from "react";
import { RATextInput, RATypography, RAButtonPrimary } from "@/components/customs";
import { SvgDirection, SvgLocation } from "@/assets/icons";
import { RAInputSearchAirport } from "@/components/atoms";
import { initFormAirFreight } from "@/utils/initializing";

export function FormAirFreightInfo({ data = initFormAirFreight, onChange, error = {} }) {
	const departureAirportRef = useRef(null);
	const arrivalAirportRef = useRef(null);

	useEffect(() => {
		if (process.env.NEXT_PUBLIC_ENV === "prod") return;
		if (!window.__airportSearchRefs) window.__airportSearchRefs = {};
		window.__airportSearchRefs["airFreight_departure"] = departureAirportRef.current;
		window.__airportSearchRefs["airFreight_arrival"] = arrivalAirportRef.current;
	}, []);

	const _renderFlightInfoByType = () => {
		return (
			<WrapperFlightInfo>
				<Row gutter={[20, 20]}>
					<Col md={12} xs={24}>
						<RAInputSearchAirport
							ref={departureAirportRef}
							title="Departure Airport"
							prefix={<SvgDirection color="#595959" />}
							placeholder="Select departure airport"
							value={data?.from_airport}
							onSelect={(val) => onChange({ ...data, from_airport: val })}
							error={error?.from_airport}
							data-testid="airFreightInfo_departureAirport"
						/>
					</Col>
					<Col md={12} xs={24}>
						<RAInputSearchAirport
							ref={arrivalAirportRef}
							title="Arrival Airport"
							prefix={<SvgLocation color="#595959" />}
							placeholder="Select arrival airport"
							value={data?.to_airport}
							onSelect={(val) => onChange({ ...data, to_airport: val })}
							error={error?.to_airport}
							data-testid="airFreightInfo_arrivalAirport"
						/>
					</Col>
				</Row>

				<WrapperHeader>
					<RATypography variant="sub-heading4">General Information</RATypography>
				</WrapperHeader>
				<Row gutter={[20, 20]}>
					<Col md={12} xs={24}>
						<RATextInput
							title="Company/Name"
							placeholder="Enter company/name"
							value={data.company_name}
							onChange={(val) => onChange({ ...data, company_name: val })}
							error={error?.company_name}
							data-testid="airFreightInfo_companyName"
						/>
					</Col>
					<Col md={12} xs={24}>
						<RATextInput
							title="Contact Name"
							placeholder="Enter contact name"
							value={data.contact?.name}
							onChange={(val) =>
								onChange({
									...data,
									contact: { ...data.contact, name: val },
								})
							}
							error={error?.contact?.name}
							data-testid="airFreightInfo_contactName"
						/>
					</Col>
				</Row>
				<Row gutter={[20, 20]}>
					<Col md={12} xs={24}>
						<RATextInput
							title="Email"
							placeholder="Enter email"
							value={data.contact?.email}
							onChange={(val) =>
								onChange({
									...data,
									contact: { ...data.contact, email: val },
								})
							}
							error={error?.contact?.email}
							data-testid="airFreightInfo_email"
						/>
					</Col>
					<Col md={12} xs={24}>
						<RATextInput
							title="Phone"
							placeholder="Enter phone number"
							type="phone"
							value={data.contact?.phone}
							onChange={(val) =>
								onChange({
									...data,
									contact: { ...data.contact, phone: val },
								})
							}
							error={error?.contact?.phone}
						/>
					</Col>
				</Row>
				<Row gutter={[20, 20]}>
					<Col md={24} xs={24}>
						<RATextInput
							title="Additional Notes"
							type="textarea"
							placeholder="Enter additional notes"
							value={data.note}
							onChange={(val) =>
								onChange({
									...data,
									note: val,
								})
							}
							data-testid="airFreightInfo_notes"
						/>
					</Col>
				</Row>

				<WrapperHeader>
					<RATypography variant="sub-heading4">Cargo Information</RATypography>
				</WrapperHeader>
				<Row gutter={[20, 20]}>
					<Col md={12} xs={24}>
						<RATextInput
							title="Quantity"
							defaultValue={0}
							type="number"
							value={data.cargo_info.quantity}
							onChange={(val) =>
								onChange({
									...data,
									cargo_info: {
										...data.cargo_info,
										quantity: val,
									},
								})
							}
							error={error?.cargo_info?.quantity}
							data-testid="airFreightInfo_quantity"
						/>
					</Col>
					<Col md={12} xs={24}>
						<RATextInput
							title="Weight (lb)"
							defaultValue={0}
							type="number"
							value={data.cargo_info.weight_lb}
							onChange={(val) =>
								onChange({
									...data,
									cargo_info: {
										...data.cargo_info,
										weight_lb: val,
									},
								})
							}
							error={error?.cargo_info?.weight_lb}
							data-testid="airFreightInfo_weight"
						/>
					</Col>
				</Row>
				<Row gutter={[20, 20]}>
					<Col md={8} xs={12}>
						<RATextInput
							title="Height (inches)"
							defaultValue={0}
							type="number"
							value={data.cargo_info.heigh_inch}
							onChange={(val) =>
								onChange({
									...data,
									cargo_info: {
										...data.cargo_info,
										heigh_inch: val,
									},
								})
							}
							error={error?.cargo_info?.heigh_inch}
							data-testid="airFreightInfo_height"
						/>
					</Col>
					<Col md={8} xs={12}>
						<RATextInput
							title="Width (inches)"
							defaultValue={0}
							type="number"
							value={data.cargo_info.width_inch}
							onChange={(val) =>
								onChange({
									...data,
									cargo_info: {
										...data.cargo_info,
										width_inch: val,
									},
								})
							}
							error={error?.cargo_info?.width_inch}
							data-testid="airFreightInfo_width"
						/>
					</Col>
					<Col md={8} xs={12}>
						<RATextInput
							title="Length (inches)"
							defaultValue={0}
							type="number"
							value={data.cargo_info.length_inch}
							onChange={(val) =>
								onChange({
									...data,
									cargo_info: {
										...data.cargo_info,
										length_inch: val,
									},
								})
							}
							error={error?.cargo_info?.length_inch}
							data-testid="airFreightInfo_length"
						/>
					</Col>
				</Row>
			</WrapperFlightInfo>
		);
	};

	return <ContainerRequestFlight>{_renderFlightInfoByType()}</ContainerRequestFlight>;
}

const ContainerRequestFlight = styled.div`
	width: "100%";
`;
const WrapperFlightInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;
const WrapperHeader = styled.div`
	padding: 8px 16px;
	min-height: 38px;
	background: #f9f9f9;
	border-radius: 4px;
	margin-top: 10px;
`;
